module.exports = __webpack_public_path__ + "static/61483326_1350153071801914_235959803820638208_n_optimized-b591b152c72b226c77347a3a1330c47c.jpg";